import React, { useMemo } from "react";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { useOrganizationReportUIContext } from "../../OrganizationReportUIContext";
import { initialFilter } from "../../OrganizationReportUIHelpers";
import { generateYearsBetween } from "../../../../../config/helper";
import { Select } from "../../../../../../_metronic/_partials/controls";

const prepareFilter = (queryParams, values) => {
  const { year, month } = values;
  const newQueryParams = { ...queryParams };
  const filter = {};

  //add to Object filter
  filter.year = year ?? "";
  filter.month = month ?? "";
  newQueryParams.filter = filter;
  return newQueryParams;
};

export const OrganizationReportFilter = ({ listLoading }) => {
  // OrganizationReport UI Context
  const organizationReportUIContext = useOrganizationReportUIContext();
  const organizationReportUIProps = useMemo(() => {
    return {
      setQueryParams: organizationReportUIContext.setQueryParams,
      queryParams: organizationReportUIContext.queryParams,
      filterType: organizationReportUIContext.filterType
    };
  }, [organizationReportUIContext]);

  const applyFilter = values => {
    const newQueryParams = prepareFilter(
      organizationReportUIProps.queryParams,
      values
    );
    if (!isEqual(newQueryParams, organizationReportUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      organizationReportUIProps.setQueryParams(newQueryParams);
    }
  };

  const currentYear = new Date().getFullYear();
  const years = generateYearsBetween(currentYear - 5, currentYear);
  const months = Array.from({ length: 12 }, (e, i) => {
    let data = {};
    data.label = new Date(null, i + 1, null).toLocaleDateString("id", {
      month: "long"
    });
    data.value = i + 1;

    return data;
  });

  return (
    <Formik
      initialValues={initialFilter.filter}
      onSubmit={values => {
        applyFilter(values);
      }}
    >
      {({ values, handleSubmit, handleBlur, setFieldValue }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <div className="form-group row">
            <div className="col-lg-4">
              <label>
                <strong>Pilih Tahun</strong>
              </label>
              <Select
                name="year"
                onChange={e => {
                  setFieldValue(e.target.name, e.target.value);
                }}
                onBlur={handleBlur}
              >
                <option value={""}>-</option>
                {years.map(year => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </Select>
            </div>
            <div className="col-lg-4">
              <label>
                <strong>Pilih Bulan</strong>
              </label>
              <Select
                name="month"
                onChange={e => {
                  setFieldValue(e.target.name, e.target.value);
                }}
                onBlur={handleBlur}
              >
                <option value={""}>-</option>

                {months.map(month => (
                  <option key={month} value={month.value}>
                    {month.label.toUpperCase()}
                  </option>
                ))}
              </Select>
            </div>
          </div>
          <div className="form-group row">
            <div className="col">
              <button
                className="btn btn-warning float-right"
                onClick={handleSubmit}
              >
                Terapkan
              </button>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
};
